import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    autosave(event) {
        this.element.requestSubmit()
    }

    submit(event) {
        event.preventDefault()
        this.element.requestSubmit()
    }
}
